module.exports = {"330206001":"大榭街道","330206002":"新碶街道","330206003":"小港街道","330206004":"大碶街道","330206005":"霞浦街道","330206006":"柴桥街道","330206007":"戚家山街道","330206008":"春晓街道","330206009":"梅山街道","330206010":"郭巨街道","330206011":"白峰街道","330206401":"保税区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/330206.json
// module id = 1060
// module chunks = 0